'use strict';
import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';
import { Navigation } from 'react-router';


var BasketEmpty = React.createClass({
    displayName: 'BasketEmpty',
    mixins: [],
    propTypes: {},
    render() {
        return (
            <div className="page baskets">
                <div className="headerbar headerbar--empty">
                    <div className="container--centered">
                    </div>
                </div>
                <div className="basket__container container--centered">
                    <h4>{flux.t('no_basket_selected')}</h4>
                    <Link to="landing-page" className="sidebar__back">
                        <i className="chevron-left"/>
                        {flux.t('back_to_home')}
                    </Link>
                </div>
            </div>);
    }
});

module.exports = BasketEmpty;



// WEBPACK FOOTER //
// ./app/components/basket/basketEmpty.jsx